import { CondictionMasterTableComponentConfig } from './shared/condictions-master-table.config.service';
import {
  CondicionControl,
  BaseControl,
  ColumnaMaestra,
  Option,
  ConfirmComponent,
  TipoControl,
  EstructuraEspecifica,
  ValoresEspecificos
} from '@app/shared/';
import { CondictionsMasterTableFormsService } from './shared/condictions-master-table.form.service';
import { Component, OnInit, EventEmitter, Output, Input, ViewChild, TemplateRef, OnDestroy } from '@angular/core';
import { LocalDataSource } from 'ng2-smart-table';
import { find } from 'lodash';
import { CondictionsMasterTableDataService } from './shared/condictions-master-table.data.service';
import { Subject } from 'rxjs';

@Component({
  selector: 'iw-condictions-master-table',
  templateUrl: './condictions-master-table.component.html',
  styleUrls: ['./condictions-master-table.component.scss'],
  providers: [ CondictionsMasterTableFormsService, CondictionsMasterTableDataService ]
})
export class CondictionsMasterTableComponent implements OnInit, OnDestroy {

  // Contiene el formulario del control
  @Input() formulario: Array<ColumnaMaestra> = [];
  // Contiene el control a condicionar
  @Input() controlCondiction: ColumnaMaestra;
  // Mensaje de la accion a realizar en el formulario de condicion
  actionForm = '';
  // Pregunta de la modal de confirmaciones
  question = '';
  // Operador condicional seleccionado temporalmente
  selectedSiEs = '';
  // Campo temporalmente seleccionado
  selectedFieldInit = '';
  // Index del registro de condicion seleccionado
  indexSelected = -1;
  // Define cuando se muestra el formulario para agregar o modificar la condicion
  formCondiction = false;
  // Define cuando se modifica la condicion o se agrega una nueva
  condictionEdit = false;
  // Configuracion de la tabla
  settings = {};
  // Contiene las opciones del formulario de condiciones
  options: any = {};
  // Condiciones de los formulario
  formulariosCondictions: Array<CondicionControl> = [];
  // Contiene los controles de el formulario de asociaciones
  controls: BaseControl<any>[] = [];
  // Campos iniciales
  fieldInit: Array<Option> = [];
  // Contiene las consultas de las columnas de las maestras
  acomulateColumns: Array<{
    name: string,
    columns: ValoresEspecificos[],
  }> = [];
  // Datos para llenar la tabla
  sourceData: LocalDataSource;
  // Condicion seleccionada
  condictionFormularioSelect: CondicionControl;
  // Condicion temporal para el cambio de el formulario
  condictionFormularioTemp: CondicionControl;
  // Destruye y gestiona el memory leak
  private destroy: Subject<void> = new Subject<void>();
  // Referencia al componente de confirmación
  @ViewChild('confirm') private confirm: ConfirmComponent;
  // Referencia a la plantilla para el control personalizado de ng-select
  @ViewChild('ngSelect') ngSelectTpl: TemplateRef<any>;
  // Emite las condiciones
  @Output() condictions: EventEmitter<Array<CondicionControl>> = new EventEmitter();

  constructor(
    private cmtfs: CondictionsMasterTableFormsService,
    private cmtds: CondictionsMasterTableDataService,
  ) { }

  ngOnInit() {
    if (this.controlCondiction) {
      if (
        this.controlCondiction.validaciones &&
        this.controlCondiction.validaciones &&
        this.controlCondiction.validaciones.condiciones.length
      ) {
        this.controlCondiction.validaciones.condiciones.forEach(condiction => {
          this.formulariosCondictions.push({
            campoDepende: condiction.campoDepende,
            siEs: condiction.siEs,
            valor: condiction.valor,
            accion: condiction.accion,
            operadorCondicion: condiction.operadorCondicion,
            expresion: condiction.expresion,
            mensajeExpresion: condiction.mensajeExpresion

          });
        });
      }
    }

    this.formulario.forEach(field => {
      if (!this.controlCondiction || this.controlCondiction.alias !== field.alias) {
        if (field.alias) {
          this.fieldInit.push({
            key: field.alias,
            value: field.alias,
          });
        }
      }
    });
    if (this.fieldInit && this.fieldInit.length) {
      this.options = {
        fieldInit: this.fieldInit
      };
    }

    const configTable = new CondictionMasterTableComponentConfig();
    this.settings = configTable.getTableCondictionsControl();
    configTable.accion.subscribe((res: any) => {
      this.defineActionCondictions(res.action, res.data);
    });

    this.loadingCondictions();
  }

  ngOnDestroy() {
    this.destroy.next();
    this.destroy.complete();
  }

  /**
   * Carga y refresca las condiciones del control
   *
   * @private
   * @memberof CondictionsMasterTableComponent
   */
  private loadingCondictions() {
    this.formulariosCondictions.forEach((condictions, index) => {
      condictions.index = index;
      if (!condictions['textSelect']) {
        condictions['value'] = condictions.valor;
      } else {
        condictions['value'] = condictions['textSelect'];
      }
    });
    this.sourceData = new LocalDataSource(this.formulariosCondictions);
    this.condictions.emit(this.formulariosCondictions);
  }

  /**
   * Controla las acciones en en la tabla de condiciones
   *
   * @param {('add' | 'update' | 'delete')} [action='add']
   * @param {*} [data]
   * @memberof CondictionsMasterTableComponent
   */
  defineActionCondictions(action: 'add' | 'update' | 'delete' = 'add', data?: any) {
    switch (action) {
      case 'add':
        this.formCondiction = true;
        this.condictionEdit = false;
        this.actionForm = 'Agregar';
        this.controls = this.cmtfs.getFormCondictionControl(this.ngSelectTpl, this.options);
        break;
      case 'update':
        this.formCondiction = true;
        this.condictionEdit = true;
        this.actionForm = 'Modificar';
        this.condictionFormularioSelect = data;
        this.indexSelected = this.condictionFormularioSelect.index;
        this.condictionFormularioTemp = data;
        this.selectedFieldInit = this.condictionFormularioSelect.campoDepende;
        let typeField: TipoControl;
        const field = find(this.formulario, {alias: this.selectedFieldInit});
        if (field) {
          if (typeof field.tipo_campo === 'object') {
            typeField = field.tipo_campo;
          }
        }
        if (field && typeField.nombre === 'ngSelect') {
          this.loadingOptionsControl(field);
        } else {
          this.controls = this.cmtfs.getFormCondictionControl(
            this.ngSelectTpl,
            this.options,
            this.condictionFormularioSelect,
            typeField,
          );
        }
        break;
      case 'delete':
        this.condictionFormularioSelect = data;
        this.indexSelected = this.condictionFormularioSelect.index;
        this.question = '¿Realmente desea eliminar la condición?';
        this.confirm.open();
        break;
    }
  }

  /**
   * Cierra el formulrio de crear o editar condicion
   *
   * @memberof CondictionsMasterTableComponent
   */
  closeFormCondiction() {
    this.formCondiction = false;
    this.selectedSiEs = '';
    this.selectedFieldInit = '';
    delete this.condictionFormularioTemp;
    this.options = {
      fieldInit: this.fieldInit
    };
    if (this.condictionEdit) {
      this.indexSelected = -1;
      this.condictionEdit = false;
      delete this.condictionFormularioSelect;
    }
  }

  /**
   * Controla los cambios en el formulario de creacion o edicion de condicion
   *
   * @param {*} data
   * @memberof CondictionsMasterTableComponent
   */
  changeForm(data: any) {
    if (data.change) {
      delete this.condictionFormularioTemp;
      this.condictionFormularioTemp = {
        campoDepende: data.change.cboFieldInit,
        siEs: data.change.cboSiEs,
        valor: data.change.txtValor,
        fechaActual: data.change.chFechaActual,
        accion: data.change.cboAction,
        operadorCondicion: data.change.cboOperactorNext,
        index: this.indexSelected,
        expresion:data.change.txtCondExpresion,
        mensajeExpresion:data.change.txtCondErrorExpresion
      };

      if (data.change.cboFieldInit && this.selectedFieldInit !== data.change.cboFieldInit) {
        this.selectedFieldInit = data.change.cboFieldInit;
        this.refreshFormCondiction();
      }

      if (data.change.cboSiEs && this.selectedSiEs !== data.change.cboSiEs) {
        this.selectedSiEs = data.change.cboSiEs;
        if (this.condictionFormularioTemp.siEs === 'Vacio') {
          delete this.condictionFormularioTemp.valor;
        }
        this.refreshFormCondiction();
      }
    }
  }

  /**
   * Refresca el formulario de crecion o edicion de condicion
   *
   * @private
   * @param {boolean} [skitType=false]
   * @memberof CondictionsMasterTableComponent
   */
  private refreshFormCondiction(skitType: boolean = false) {
    let typeField: TipoControl;
    const field = find(this.formulario, {alias: this.selectedFieldInit});
    if (field) {
      if (typeof field.tipo_campo === 'object') {
        typeField = field.tipo_campo;
      }
    }
     if (!skitType) {
        if (field && typeField.nombre === 'ngSelect') {
          this.loadingOptionsControl(field);
        } else {
          this.controls = this.cmtfs.getFormCondictionControl(
            this.ngSelectTpl,
            this.options,
            this.condictionFormularioTemp,
            typeField
          );
        }
      } else {
        this.controls = this.cmtfs.getFormCondictionControl(
          this.ngSelectTpl,
          this.options,
          this.condictionFormularioTemp,
          typeField
        );
      }
  }

  /**
   * Guarda o edita la condicion
   *
   * @param {*} data
   * @memberof CondictionsMasterTableComponent
   */
  sended(data: any) {
    const moment = require('moment');
    let date = false;
    if (data.txtValor && moment(new Date(data.txtValor)).isValid()) {
      date = true;
    } else if (data.chFechaActual) {
      date = true;
    }
    const newCondiction: CondicionControl = {
      campoDepende: data.cboFieldInit,
      siEs: data.cboSiEs,
      valor: data.txtValor,
      fechaActual: data.chFechaActual,
      accion: data.cboAction,
      operadorCondicion: data.cboOperactorNext,
      expresion: data.txtCondExpresion,
      mensajeExpresion:data.txtCondErrorExpresion
    };

    const field = find(this.formulario, {alias: this.selectedFieldInit});
    if (field) {
      if (typeof field.tipo_campo === 'object' && field.tipo_campo.nombre === 'ngSelect') {
        const rows = find(this.acomulateColumns, {name: field.id + ' '});
        if (rows) {
          const valor = find(rows.columns, {id: data.txtValor});
          let labelSelect = '';
          if (valor) {
            field.propiedades['columnas_seleccionadas'].forEach((col: string, index: any) => {
              if (index > 0) {
                labelSelect += ' / ';
              }
              if (valor.valores[col]) {
                labelSelect += valor.valores[col];
              } else {
                labelSelect += 'No aplica';
              }
            });
          }
          newCondiction['textSelect'] = labelSelect;
        }
      } else if (typeof field.tipo_campo === 'object' && field.tipo_campo.nombre === 'checkbox') {
        if (data.txtValor === 'true') {
          newCondiction['textSelect'] = 'Seleccionado';
        } else {
          newCondiction['textSelect'] = 'No seleccionado';
        }
      } else if (
        date &&
        (
          data.txtValor instanceof Date ||
          (
            typeof field.tipo_campo === 'object' &&
            field.tipo_campo.nombre === 'date-time-picker'
          )
        )
      ) {
        const dateValor: Date = new Date(data.txtValor);
        if (
          typeof field.tipo_campo === 'object' &&
          field.tipo_campo.nombre === 'date-time-picker' &&
          field.propiedades &&
          field.propiedades['tipo']
        ) {
          if (moment(dateValor).isValid()) {
            dateValor.setSeconds(0, 0);
            switch (field.propiedades['tipo']) {
              case 'calendar':
                newCondiction['textSelect'] = dateValor.toLocaleDateString();
                break;
              case 'timer':
                newCondiction['textSelect'] = dateValor.toLocaleTimeString();
                break;
              default:
                newCondiction['textSelect'] = dateValor.toLocaleDateString() + ' ' + dateValor.toLocaleTimeString();
                break;
            }
          } else {
            if (newCondiction.fechaActual) {
              newCondiction['textSelect'] = 'Fecha actual';
            }
          }
        } else {
          if (moment(dateValor).isValid()) {
            dateValor.setSeconds(0, 0);
            newCondiction['textSelect'] = dateValor.toLocaleDateString() + ' ' + dateValor.toLocaleTimeString();
          } else {
            if (newCondiction.fechaActual) {
              newCondiction['textSelect'] = 'Fecha actual';
            }
          }
        }
        if (moment(dateValor).isValid()) {
          newCondiction.valor = dateValor;
        } else {
          if (newCondiction.fechaActual) {
            newCondiction['textSelect'] = 'Fecha actual';
          }
        }
      }
    }

    if (!this.condictionEdit) {
      this.formulariosCondictions.push(newCondiction);
    } else {
      this.formulariosCondictions[this.indexSelected] = newCondiction;
    }
    this.closeFormCondiction();
    this.loadingCondictions();
  }

  /**
   * Controla las acciones en el modal de confirmaciones
   *
   * @param {boolean} res
   * @memberof CondictionsMasterTableComponent
   */
  actionComfirm(res: boolean) {
    if (res) {
      this.deleteCondictions();
    }
    this.question = '';
  }

  /**
   * Elimina una condicion
   *
   * @private
   * @memberof CondictionsMasterTableComponent
   */
  private deleteCondictions() {
    this.formulariosCondictions.splice(this.indexSelected, 1);
    this.loadingCondictions();
    this.closeFormCondiction();
  }

  /**
   * Carga los datos de la maestra del select indicado
   *
   * @private
   * @param {ColumnaMaestra} field
   * @memberof CondictionsMasterTableComponent
   */
  private async loadingOptionsControl(field: ColumnaMaestra) {
    if (field.tipo_campo['nombre'] === 'ngSelect') {
      const columnsMaster: Array<{
        key: string,
        value: number
      }> = [];
      // let specificEstructure: EstructuraEspecifica;
      // specificEstructure = {
        //   maestra: field.maestra_dependencia['id'],
        //   columnas: [],
        //   dependencia: []
        // };
        let columns: ValoresEspecificos[];
        const colsMaster = find(this.acomulateColumns, {name: field.id + ' '});
        if (!colsMaster) {
          const specificEstructure: EstructuraEspecifica = this.generateStructureMasterTable(
            field.maestra_dependencia['id'],
            field.propiedades['columnas_seleccionadas']
          );
        // Se crea la estructura de la consulta de las columnas relacionadas a la maestra para el ngselect
        // field.propiedades['columnas_seleccionadas'].forEach((col: string, index: number) => {
        //   const cols = col.split('_');
        //   const column = Number(cols[0]);
        //   if (cols.length === 1) {
        //     if (typeof field.maestra_dependencia === 'object') {
        //       const structure = find(field.maestra_dependencia.estructura, { id: column });

        //       // if (structure) {
        //         // field.propiedades['columnas_seleccionadas'].slice(index, 1);
        //         specificEstructure.columnas.push(column + ' ');
        //       // }
        //     }
        //   }
        // });
        // if (field.propiedades['columnas_seleccionadas'].length) {
        //   const blockColumns: Array<string[]> = [];
        //   if (field.propiedades['columnas_seleccionadas']) {
        //     let columnDependence = '';
        //     field.propiedades['columnas_seleccionadas'].forEach((col: string, index: number) => {
        //       const column = col.split('_');
        //       if (column.length > 1) {
        //         if (columnDependence !== column[0]) {
        //           columnDependence = column[0];
        //           const blockColumnsRecolector: Array<string> = [];
        //           field.propiedades['columnas_seleccionadas'].forEach((colDep: string, indexDep: number) => {
        //             const columnsRef = colDep.split('_');
        //             if (columnsRef[0] === columnDependence) {
        //               blockColumnsRecolector.push(colDep);
        //             }
        //           });
        //           blockColumns.push(blockColumnsRecolector);
        //         }
        //       }
        //     });
        //   }
        //   blockColumns.forEach(columnsSeleted => {
        //     const history = this.loadingEstructureColumns(
        //       field.maestra_dependencia['estructura'],
        //       columnsSeleted,
        //       Number(columnsSeleted[0].split('_')[0])
        //     );

        //     if (history) {
        //       specificEstructure.dependencia.push(history);
        //     }
        //   });
        // }
        columns = await this.cmtds.getColumnsSpecificMasterTable(specificEstructure);
        this.acomulateColumns.push({
          name: field.id + ' ',
          columns: columns
        });
      } else {
        columns = colsMaster.columns;
      }
      // se setean los labels a mostrar en el select
      columns.forEach(column => {
        let labelSelect = '';
        field.propiedades['columnas_seleccionadas'].forEach((col: string, index: any) => {
          if (index > 0) {
            labelSelect += ' / ';
          }
          if (column.valores[col]) {
            labelSelect += column.valores[col];
          } else {
            labelSelect += 'No aplica';
          }
        });
        columnsMaster.push({ value: column.id, key: labelSelect });
      });
      this.options['optColumnMaster'] = columnsMaster;
      this.refreshFormCondiction(true);
    } else {
      delete this.options['optColumnMaster'];
      this.refreshFormCondiction(true);
    }
  }

  /**
   * Pendiente para revisar su funcionalida
   * Realiza la estructura para la consulta de las columnas seleccionadas para mostrar en las tablas y selects
   *
   * @private
   * @param {ColumnaMaestra[]} structure
   * @param {Array<string>} columns
   * @param {number} [idDependence=0]
   * @returns {EstructuraEspecifica}
   * @memberof CondictionsMasterTableComponent
   */
  private loadingEstructureColumns(
    structure: ColumnaMaestra[],
    columns: Array<string>,
    idDependence: number = 0
  ): EstructuraEspecifica {
    let specificEstructure: EstructuraEspecifica;
    const cls: Array<string> = [];
    specificEstructure = {
      maestra: null,
      columnas: [],
      dependencia: []
    };
    columns.forEach(el => {
      cls.push(el);
    });
    for (const field of structure) {
      if (field.tipo_campo['nombre'] === 'ngSelect') {
        if (idDependence !== 0 && idDependence !== field.id) {
          continue;
        }
        specificEstructure.maestra = field.id + ' ';
        cls.forEach((col: string, index: number) => {
          const  cols = col.split('_');
          const column = Number(cols[1]);
          if (cols.length === 2) {
            const dependenc = Number(cols[0]);
            if (typeof field.maestra_dependencia === 'object') {
              const columnField = find(field.maestra_dependencia.estructura, {id: column});
                if (dependenc === field.id) {

                if (columnField) {
                  specificEstructure.columnas.push(column + ' ');
                }
              }
            }
          } else if (cols.length > 2) {
            const cl = cols.slice(1);
            cls[index] = '';
            cl.forEach((el: any, indexCol: number) => {
              cls[index] += el;

              if (indexCol < (cl.length - 1)) {
                cls[index] += '_';
              }

            });
          }
        });
        if (cls.length) {
          const newLevel = this.loadingEstructureColumns(field.maestra_dependencia['estructura'], cls);
          if (newLevel) {
            specificEstructure.dependencia.push(newLevel);
            break;
          }
        }
      }
    }
    if (specificEstructure.maestra && (specificEstructure.columnas.length || specificEstructure.dependencia.length)) {
      return specificEstructure;
    } else {
      return null;
    }
  }

  /**
   * Realiza la estructura para la consulta de las columnas seleccionadas para mostrar en las tablas y selects
   *
   * @private
   * @param {string} idMaster
   * @param {string[]} columns
   * @returns {EstructuraEspecifica}
   * @memberof CondictionsMasterTableComponent
   */
  private generateStructureMasterTable(idMaster: string, columns: string[]): EstructuraEspecifica {
    const columnsByDependece = {};
    const idMasterByDependece: Array<any> = [];
    const structure: EstructuraEspecifica = {
      maestra: idMaster,
      columnas: [],
      dependencia: []
    };
    if (columns && columns.length) {
      columns.forEach(column => {
        const cols = column.split('_');
        if (cols.length > 1) {
          let structureCol = '';
          const idMasterCol = cols[0];
          cols.splice(0, 1);
          cols.forEach((col, i) => {
            if (i !== 0) {
              structureCol += '_';
            }
            structureCol += col;
          });
          if (columnsByDependece[String(idMasterCol)]) {
            columnsByDependece[String(idMasterCol)].push(structureCol);
          } else {
            idMasterByDependece.push(idMasterCol);
            columnsByDependece[String(idMasterCol)] = [structureCol];
          }
        } else {
          structure.columnas.push(cols[0] + ' ');
        }
      });
    }
    if (idMasterByDependece.length) {
      idMasterByDependece.forEach((idMasterDependence: any) => {
        structure.dependencia.push(
          this.generateStructureMasterTable(
            idMasterDependence + ' ',
            columnsByDependece[idMasterDependence]
          )
        );
      });
    }
    return structure;
  }

}



// WEBPACK FOOTER //
// ./src/app/administration/teacher/master-structure/condictions-master-table/condictions-master-table.component.ts